import { mixer } from './audio-mixer.js';
import { ChannelSoundSequence } from './channel-sound-sequence.js';
import { CAST_BED_DB, decibels } from './mix.js';

const files = import.meta.glob('../assets/audio/sfx/spells/channel/*.{mp3,wav,flac,ogg}', { eager: true, query: '?url', import: 'default' }) as Record<string, string>;
const pools = ['channel start', 'channeling', 'channel end'].map(name => Object.entries(files).filter(([path]) => path.split('/').pop()!.startsWith(`${name} `)).map(([, url]) => url));
export function createChannelSounds() {
  void mixer.preloadSfx(Object.values(files));
  // Each part of the bed plays at the matched loudness, set back under the incantation and the blows (`mix.ts`).
  const engine = mixer.engine;
  return new ChannelSoundSequence({
    duration: url => engine.duration(url),
    controlled: (url, options) => engine.controlled(url, options, 'effects', engine.match(url) * decibels(CAST_BED_DB)),
  }, pools);
}
